import React from 'react'
import "../css/main.css"

import TipyNaVylety_main from "../public/tipynavylety/tipynavylety_2.svg"
import TipyNaVylety_second from "../public/tipynavylety/tipynavylety_1.svg"


import TipyNaVylety_1 from "../public/tipynavylety/tipynavylety_1.png"
import TipyNaVylety_2 from "../public/tipynavylety/tipynavylety_2.png"
import TipyNaVylety_3 from "../public/tipynavylety/tipynavylety_3.png"
import TipyNaVylety_4 from "../public/tipynavylety/tipynavylety_4.png"

import { Link } from 'react-router-dom'

import { useContext } from "react";
import { DarkModeContext } from "../components/DarkModeProvider"


const TipyNaVylety = () => {

    const { darkMode } = useContext(DarkModeContext);

    return (
        <>
            <section className={darkMode ? 'tips__for--trips dark' : 'tips__for--trips light'}>
                <div className="container">
                    <div className="tips__for--trips-container">
                        <div className="tips__for--trips-heading">
                            <img src={darkMode ? TipyNaVylety_second : TipyNaVylety_main} alt="" />
                            <h1 className={darkMode ? 'dark-text' : 'light-text'}>Tipy na výlety v Česku</h1>
                        </div>
                        <div className="tips__for--trips-content">
                            <Link to="/beskydy/kamsevydat" className="card">
                                <div className="card-image">
                                    <img src={TipyNaVylety_1} alt="" />
                                </div>
                                <h3>Beskydy</h3>
                            </Link>

                            <Link to="/jeseniky/kamsevydat" className="card">
                                <div className="card-image">
                                    <img src={TipyNaVylety_2} alt="" />
                                </div>
                                <h3>Jeseníky</h3>
                            </Link>

                            <Link to="/krkonose/kamsevydat" className="card">
                                <div className="card-image">
                                    <img src={TipyNaVylety_3} alt="" />
                                </div>
                                <h3>Krkonoše</h3>
                            </Link>

                            <Link to="/sumava/kamsevydat" className="card">
                                <div className="card-image">
                                    <img src={TipyNaVylety_4} alt="" />
                                </div>
                                <h3>Šumava</h3>
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default TipyNaVylety;